import { render, staticRenderFns } from "./AccountDefaultCard.vue?vue&type=template&id=9cf35462&scoped=true"
import script from "./AccountDefaultCard.vue?vue&type=script&lang=js"
export * from "./AccountDefaultCard.vue?vue&type=script&lang=js"
import style0 from "./AccountDefaultCard.vue?vue&type=style&index=0&id=9cf35462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf35462",
  null
  
)

export default component.exports